<template>
    <div class="columns">
        <div class="column">
            <div class="column">
                <div style="padding-top: 20px; width: 100%;">
                    <app-loader :loading="isLoading" :color="options.color" :size="options.size"></app-loader>
                    <table class="table is-responsive is-fullwidth" v-if="!isLoading">
                        <thead>
                        <tr>
                            <th>Invoice #</th>
                            <th>Shipping Group Id</th>
                            <th>Payment Term</th>
                            <th>Remarks</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="proforma in multiProformas">
                            <td>{{ proforma.id }}</td>
                            <td>{{ proforma.group_ids }}</td>
                            <td>{{ proforma.payment_term }}</td>
                            <td>{{ proforma.remarks }}</td>
                            <td>{{ proforma.created_at }}</td>
                            <td>
                                <button class="button"
                                        @click.prevent="downloadMultiproforma(proforma.id)">
                                            <span class="icon is-small">
                                              <i class="fas fa-file-excel"></i>
                                            </span>
                                    <span>Output (EXCEL)</span>
                                </button>
                                <button class="button"
                                        @click.prevent="downloadMultiproformaPDF(proforma.id)">
                                            <span class="icon is-small">
                                              <i class="fas fa-file-pdf"></i>
                                            </span>
                                    <span>Output (PDF)</span>
                                </button>
                                <button class="button is-danger"
                                        @click.prevent="updateMutliProforma(proforma.id)">
                                    <span>UPDATE</span>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                <multi-proforma-invoice-modal v-if="modalStatus"></multi-proforma-invoice-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiProformaInvoices from './../../../../api/apiProformaInvoices'
    import appLoader from 'vue-spinner/src/ClipLoader'
    import MultiProformaInvoiceModal from "./MultiProformaModal/MultiProformaInvoiceModal";

    export default {
        props: ['user'],
        components: {
            MultiProformaInvoiceModal,
            appLoader: appLoader,
        },
        data() {
            return {
                options: this.$store.getters.getOptions,

            }
        },
        computed: {
            modalStatus() {
                return this.$store.getters.getUpdateMultiProformaModal
            },
            multiProformas(){
                return this.$store.getters.getMultiProformas
            },
            isLoading(){
                return this.$store.getters.getMultiProformasLoading
            }
        },
        methods: {
            downloadMultiproforma(id) {
                apiProformaInvoices
                    .downloadShippingMultiproformaInvoices(id)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'MULTI_INV.xlsx')
                        document.body.appendChild(link)
                        link.click()
                        commit('setDownloadStatus', false)
                        resolve()
                    })
                    .catch(error => {
                        commit('setDownloadStatus', false)
                        console.log(error)
                        //commit('setErrors', JSON.parse(error.response.data))
                        reject()
                    })
            },
            downloadMultiproformaPDF(id) {
                apiProformaInvoices
                    .downloadMultiproformaPDF(id)
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]))
                        const link = document.createElement('a')
                        link.href = url
                        const name = Number(id).toString().padStart(6, 0)
                        link.setAttribute('download', 'MULTI_INV-' + name + '.pdf')
                        document.body.appendChild(link)
                        link.click()
                    })
                    .catch((error) => console.log(error))
            },
            updateMutliProforma(id){
                //this.$store.dispatch('updateMultiProformaModal', true)
                this.$store.dispatch('getMultiProforma', id)
            }
        },
        created() {

            this.$store.dispatch('setMultiProformasLoading', true)
            this.$store.dispatch('getUserMultiProformas', this.user.id)

        },
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/UserMultiProforma.vue